"use client";

import { Icon, Delta } from "@/components/Icons";
import { TYPE_LIB } from "@/lib/data";
import { useStock } from "@/context/StockContext";
import { euro, nb, statut } from "@/lib/utils";

export function AccueilView() {
  const { produits, mouvements, findProduit, go, setFiltre, lignesAAssocier, nbEcarts } = useStock();
  const unites = produits.reduce((s, p) => s + p.qte, 0);
  const valeur = produits.reduce((s, p) => s + p.qte * p.pa, 0);
  const bas = produits
    .filter((p) => statut(p) !== "ok")
    .sort((a, b) => a.qte / a.seuil - b.qte / b.seuil);
  const aAssoc = lignesAAssocier().length;
  const ecarts = nbEcarts();

  const todo: { nav: "ventes" | "fournisseurs" | "reception"; ic: string; i: string; t: string; s: string }[] = [];
  if (aAssoc)
    todo.push({
      nav: "ventes",
      ic: "warn",
      i: "link",
      t: `${aAssoc} ligne${aAssoc > 1 ? "s" : ""} de vente à associer`,
      s: "Ventes Pennylane sans référence produit",
    });
  if (ecarts)
    todo.push({
      nav: "fournisseurs",
      ic: "bad",
      i: "alert",
      t: `${ecarts} facture${ecarts > 1 ? "s" : ""} fournisseur avec écart`,
      s: "Quantité ou prix différent de la réception",
    });
  todo.push({
    nav: "reception",
    ic: "info",
    i: "camera",
    t: "Enregistrer une livraison",
    s: "Photo du bon de livraison, l'IA remplit les lignes",
  });

  return (
    <>
      <div className="kpis">
        <div className="kpi">
          <span className="eyebrow">Références</span>
          <b>{produits.length}</b>
          <span className="muted">{nb(unites)} unités</span>
        </div>
        <div className="kpi">
          <span className="eyebrow">Valeur du stock</span>
          <b>{euro(valeur)}</b>
          <span className="muted">au prix d&apos;achat</span>
        </div>
        <div className="kpi alert">
          <span className="eyebrow">À réapprovisionner</span>
          <b>{bas.length}</b>
          <span className="muted">dont {bas.filter((p) => p.qte === 0).length} en rupture</span>
        </div>
        <div className={`kpi ${aAssoc + ecarts ? "alert" : ""}`}>
          <span className="eyebrow">À traiter</span>
          <b>{aAssoc + ecarts}</b>
          <span className="muted">ventes + factures</span>
        </div>
      </div>
      <div className="grid2">
        <div className="stack">
          <div className="card">
            <div className="card-h">
              <h2>À faire</h2>
            </div>
            <div className="todo">
              {todo.map((x) => (
                <button key={x.t} type="button" onClick={() => go(x.nav)}>
                  <span className={`ic ${x.ic}`}>
                    <Icon name={x.i} />
                  </span>
                  <span>
                    <span className="t">{x.t}</span>
                    <br />
                    <span className="s">{x.s}</span>
                  </span>
                  <span className="muted" style={{ width: 18 }}>
                    <Icon name="chevron" />
                  </span>
                </button>
              ))}
            </div>
          </div>
          <div className="card">
            <div className="card-h">
              <h2>Derniers mouvements</h2>
              <span className="muted" style={{ fontSize: ".85rem" }}>
                Ventes, réceptions, recomptages
              </span>
            </div>
            <ul className="feed">
              {mouvements.slice(0, 7).map((m, i) => {
                const p = findProduit(m.ref);
                return (
                  <li key={`${m.ref}-${i}`}>
                    <span className="tag">{TYPE_LIB[m.type]}</span>
                    <span style={{ minWidth: 0 }}>
                      <span className="name">{p?.nom || m.ref}</span>
                      <br />
                      <span className="muted" style={{ fontSize: ".84rem" }}>
                        {m.source} · {m.quand}
                      </span>
                    </span>
                    <Delta d={m.delta} />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="card">
          <div className="card-h">
            <h2>Sous le seuil</h2>
            <button
              className="btn small"
              type="button"
              onClick={() => {
                setFiltre("bas");
                go("stock");
              }}
            >
              Tout voir
            </button>
          </div>
          <ul className="list low">
            {bas.map((p) => (
              <li key={p.ref}>
                <span style={{ minWidth: 0 }}>
                  <span className="name">{p.nom}</span>
                  <br />
                  <span className="loc">{p.emp}</span>{" "}
                  <span className="mono muted">{p.ref}</span>
                </span>
                <span style={{ display: "grid", justifyItems: "end", gap: 5 }}>
                  <span className="qty">
                    {p.qte}
                    <span className="muted" style={{ fontSize: ".8rem", fontWeight: 500 }}>
                      {" "}
                      / {p.seuil}
                    </span>
                  </span>
                  <span className="gauge">
                    <i style={{ width: `${Math.min(100, (p.qte / p.seuil) * 100)}%` }} />
                  </span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
